var map = {
	"./australia.svg": 12031,
	"./bangladesh.svg": 20939,
	"./canada.svg": 19956,
	"./china.svg": 86566,
	"./cook.svg": 47093,
	"./default.svg": 77286,
	"./fiji.svg": 35403,
	"./french_polynesia.svg": 72890,
	"./hawaii.svg": 92817,
	"./hong_kong.svg": 72787,
	"./india.svg": 46672,
	"./macau.svg": 93329,
	"./malaysia.svg": 3596,
	"./nepal.svg": 96753,
	"./niue.svg": 5667,
	"./pakistan.svg": 76811,
	"./samoa.svg": 25233,
	"./singapore.svg": 54126,
	"./sri_lanka.svg": 15067,
	"./taiwan.svg": 94971,
	"./tonga.svg": 76208,
	"./uae.svg": 48139,
	"./uk.svg": 44216,
	"./usa.svg": 51585,
	"./vietnam.svg": 45612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64735;